module.exports = __webpack_public_path__ + "static/media/SquiggleBlue.4337b100.svg";